import React from "react";
import { Card } from 'react-bootstrap';
import { showInParagraphs } from "./utils";

export default function SituationCard({ data }) {
    const createSlug = (title) => {
        return title
          .toLowerCase()
          .replace(/&/g, 'and')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
    };
    
    const handleClick = () => {
        window.location.href = "hireme/" + createSlug(data.title);
      };

    return (
        <Card className = "h-100 shadow-sm card-theme rounded">
            <Card.Img variant="top" className="service-card-img" src={"./images/"+ data.image} />
            <Card.Body className="d-flex flex-column">
                <Card.Title className="mb-0 font-weight-bold text-theme-accent2" onClick={handleClick}>{data.title}</Card.Title>
                <hr/>

                <div className="text-theme-accent3" onClick={handleClick}>{
                    showInParagraphs(data.need)
                }</div>
                <div className="text-theme-accent3" onClick={handleClick}>{
                    showInParagraphs(data.description)
                }</div>
                <a href={"hireme/" + createSlug(data.title)} className="btn btn-dark mt-auto font-weight-bold">Find out more</a>
            </Card.Body>
        </Card>
    )
}